/* NEPO base44 replication — reveal, mobile nav, media video, and AJAX cart. */
(function(){
  /* ---------- scroll reveal ---------- */
  function reveal(){
    var els=document.querySelectorAll('.n44-reveal:not(.is-in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in');});return;}
    var io=new IntersectionObserver(function(es){es.forEach(function(e){
      if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},
      {threshold:.12,rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){io.observe(e);});
  }
  /* ---------- card / pdp video hover ---------- */
  function cardVideos(){
    document.querySelectorAll('.n44-card__media video').forEach(function(v){
      if(v.dataset.n44bound) return; v.dataset.n44bound='1';
      var card=v.closest('.n44-card');
      if(!card) return;
      card.addEventListener('mouseenter',function(){ if(v.paused){var p=v.play();if(p&&p.catch)p.catch(function(){});} });
      card.addEventListener('mouseleave',function(){ v.pause(); });
    });
  }
  function pdpSpin(){
    document.querySelectorAll('[data-n44-pdp-spin]').forEach(function(btn){
      if(btn.dataset.n44bound) return; btn.dataset.n44bound='1';
      var media=btn.closest('.n44-pdp__media'); if(!media) return;
      var v=media.querySelector('video'); if(!v) return;
      v.removeAttribute('loop');
      btn.addEventListener('click',function(){
        if(media.classList.contains('show-video')) return;
        media.classList.add('show-video');
        try{ v.currentTime=0; }catch(e){}
        var p=v.play(); if(p&&p.catch)p.catch(function(){ media.classList.remove('show-video'); });
      });
      v.addEventListener('ended',function(){ media.classList.remove('show-video'); });
    });
  }
  function mobileNav(){
    document.querySelectorAll('[data-n44-nav-toggle]').forEach(function(btn){
      if(btn.dataset.n44bound) return; btn.dataset.n44bound='1';
      btn.addEventListener('click',function(){btn.closest('.n44-header').classList.toggle('is-open');});
    });
  }

  /* ---------- AJAX cart ---------- */
  function money(cents, currency){
    try{ return new Intl.NumberFormat(navigator.language||'en',{style:'currency',currency:currency||'EUR'}).format(cents/100); }
    catch(e){ return (cents/100).toFixed(2)+' '+(currency||''); }
  }
  function drawerExists(){ return !!document.querySelector('[data-n44-cart-body]'); }
  function openCart(){
    if(!drawerExists()){ window.location.href='/cart'; return; }
    document.documentElement.classList.add('n44-cart-open');
  }
  function closeCart(){ document.documentElement.classList.remove('n44-cart-open'); }
  function getCart(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); }

  function updateCounts(cart){
    document.querySelectorAll('.n44-cart-count').forEach(function(e){
      e.textContent=cart.item_count;
      e.classList.toggle('is-empty', cart.item_count===0);
    });
  }
  function thumb(url){ return url? url.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?|$)/i,'_200x$1$2') : ''; }
  function bumpCart(){ document.querySelectorAll('.n44-cart-count').forEach(function(e){ e.classList.remove('is-bump'); void e.offsetWidth; e.classList.add('is-bump'); }); }

  function renderDrawer(cart){
    updateCounts(cart);
    var body=document.querySelector('[data-n44-cart-body]');
    var foot=document.querySelector('[data-n44-cart-foot]');
    if(!body) return;
    if(cart.item_count===0){
      body.innerHTML='<p class="n44-cart-empty">Your vault is empty.</p>';
      if(foot) foot.hidden=true; return;
    }
    if(foot) foot.hidden=false;
    body.innerHTML=cart.items.map(function(it){
      var sub=(it.variant_title && it.variant_title!=='Default Title')? it.variant_title : 'Sterling Silver 925';
      return '<div class="n44-citem" data-key="'+it.key+'">'
        +'<a class="n44-citem__img" href="'+it.url+'">'+(it.image?'<img src="'+thumb(it.image)+'" alt="">':'')+'</a>'
        +'<div class="n44-citem__main">'
          +'<a class="n44-citem__name" href="'+it.url+'">'+it.product_title+'</a>'
          +'<div class="n44-citem__sub">'+sub+'</div>'
          +'<div class="n44-citem__row">'
            +'<div class="n44-qty"><button type="button" data-n44-dec aria-label="Decrease">&minus;</button><span>'+it.quantity+'</span><button type="button" data-n44-inc aria-label="Increase">+</button></div>'
            +'<span class="n44-citem__price">'+money(it.final_line_price,cart.currency)+'</span>'
          +'</div>'
          +'<button type="button" class="n44-citem__remove" data-n44-remove>Remove</button>'
        +'</div>'
      +'</div>';
    }).join('');
    var sub=document.querySelector('[data-n44-subtotal]');
    if(sub) sub.textContent=money(cart.total_price,cart.currency);
  }

  function changeQty(key,qty){
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();});
  }
  function addToCart(id,qty){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:id,quantity:qty||1}]})})
      .then(function(r){
        return r.json().then(function(j){
          if(r.ok) return {ok:true};
          return {ok:false,msg:(j&&(j.description||j.message))||'Could not add to vault'};
        });
      })
      .catch(function(){ return {ok:false,msg:'Could not add to vault — check your connection'}; });
  }
  function showFormError(form,msg){
    var el=form.querySelector('.n44-add-error');
    if(!el){
      el=document.createElement('p');
      el.className='n44-add-error';
      el.setAttribute('role','alert');
      el.style.cssText='margin:10px 0 0;font-size:12px;letter-spacing:.04em;color:#c98c8c;';
      form.appendChild(el);
    }
    el.textContent=msg;
  }
  function clearFormError(form){
    var el=form.querySelector('.n44-add-error'); if(el) el.textContent='';
  }
  /* direct path to checkout right under the buy button — never depends on the drawer */
  function markAdded(form){
    var el=form.querySelector('.n44-add-ok');
    if(!el){
      el=document.createElement('a');
      el.className='n44-add-ok';
      el.href='/cart/checkout';
      el.style.cssText='display:block;margin:14px 0 0;text-align:center;font-size:12px;letter-spacing:.18em;text-transform:uppercase;color:#e8e6df;text-decoration:underline;text-underline-offset:5px;';
      form.appendChild(el);
    }
    el.textContent='In the vault · Proceed to checkout →';
  }
  function diagnose(form,id,baseMsg){
    Promise.all([
      fetch(location.pathname.replace(/\/+$/,'')+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.ok?r.json():null;}).catch(function(){return null;}),
      getCart().catch(function(){return null;})
    ]).then(function(res){
      var p=res[0], cart=res[1], bits=[];
      if(p&&p.variants){
        var v=p.variants.filter(function(x){return String(x.id)===String(id);})[0];
        bits.push(v? ('site sees '+v.title+': '+(v.available?'available':'NOT available')) : 'variant '+id+' not on this page');
      }
      if(cart&&cart.items){
        var line=cart.items.filter(function(x){return String(x.variant_id||x.id)===String(id);})[0];
        bits.push('in cart already: '+(line?line.quantity:0));
      }
      if(bits.length) showFormError(form, baseMsg+'  ·  ['+bits.join(' · ')+']');
    });
  }

  function bindCart(){
    document.addEventListener('click',function(e){
      if(e.target.closest('[data-n44-cart-toggle]')){ e.preventDefault(); if(!drawerExists()){ window.location.href='/cart'; return; } getCart().then(function(c){renderDrawer(c);openCart();}); return; }
      if(e.target.closest('[data-n44-cart-close]')||e.target.classList.contains('n44-cart-scrim')){ closeCart(); return; }
      var inc=e.target.closest('[data-n44-inc]'), dec=e.target.closest('[data-n44-dec]'), rem=e.target.closest('[data-n44-remove]');
      if(inc||dec||rem){
        var row=e.target.closest('.n44-citem'); if(!row) return;
        var key=row.getAttribute('data-key');
        var now=parseInt(row.querySelector('.n44-qty span').textContent,10)||1;
        var nq=rem?0:(inc?now+1:now-1); if(nq<0)nq=0;
        changeQty(key,nq).then(renderDrawer);
      }
    });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeCart(); });
    document.addEventListener('submit',function(e){
      var form=e.target.closest('[data-n44-add]'); if(!form) return;
      e.preventDefault();
      var id=new FormData(form).get('id');
      if(!id){ showFormError(form,'Please choose a size.'); return; }
      var q=parseInt((form.querySelector('[name=quantity]')||{}).value||'1',10)||1;
      var btn=form.querySelector('button[type=submit]'); var orig=btn?btn.textContent:'';
      clearFormError(form);
      if(btn){btn.disabled=true;btn.textContent='Adding…';}
      addToCart(id,q).then(function(res){
        if(btn){btn.disabled=false;btn.textContent=orig;}
        if(res.ok){ bumpCart(); markAdded(form); getCart().then(function(c){renderDrawer(c);openCart();}); }
        else { showFormError(form,res.msg); diagnose(form,id,res.msg); }
      });
    });
  }

  /* ---------- open Horizon's predictive-search modal from the header icon ---------- */
  var searchBound=false;
  function searchOpen(){
    if(searchBound) return; searchBound=true;
    document.addEventListener('click',function(e){
      var t=e.target.closest('[data-n44-search-open]'); if(!t) return;
      var modal=document.getElementById('search-modal');
      if(modal && typeof modal.showDialog==='function'){ e.preventDefault(); modal.showDialog(); }
    });
  }
  /* ---------- prefetch internal pages on hover/tap ---------- */
  var pfBound=false, pfSeen={};
  function prefetchNav(){
    if(pfBound) return; pfBound=true;
    function pf(e){
      var a=e.target.closest && e.target.closest('a[href]'); if(!a) return;
      if(a.origin!==location.origin) return;
      if(a.hasAttribute('data-n44-cart-toggle')||a.hasAttribute('data-n44-search-open')||a.hasAttribute('data-n44-nav-toggle')) return;
      if(/\/(cart|account|checkout)(\/|$|\?|#)/.test(a.pathname)) return;
      var href=a.href.split('#')[0]; if(pfSeen[href]||href===location.href.split('#')[0]) return;
      pfSeen[href]=1;
      var l=document.createElement('link'); l.rel='prefetch'; l.as='document'; l.href=href; document.head.appendChild(l);
    }
    document.addEventListener('pointerover',pf,{capture:true,passive:true});
    document.addEventListener('touchstart',pf,{capture:true,passive:true});
  }

  var cartBound=false;
  function init(){
    reveal();cardVideos();pdpSpin();mobileNav();searchOpen();prefetchNav();
    if(!cartBound){ bindCart(); cartBound=true; getCart().then(updateCounts).catch(function(){}); }
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();
